/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { Logout, AuthPage, useAuth } from '../modules/auth'
import { App } from '../App'
import { getDashboardPath } from '../utils/helper'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const basename = process.env.PUBLIC_URL || '/';

const AppRoutes: FC = () => {
  const { currentUser } = useAuth()
  
  const getRedirectPath = () => {
    const role = currentUser?.role || currentUser?.user_type
    const userType = currentUser?.user_type
    return getDashboardPath(role, userType)
  }

  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route element={<App />}>
          <Route path='logout' element={<Logout />} />
          <Route path='error/*' element={<ErrorsPage />} />
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to={getRedirectPath()} />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export { AppRoutes }
